import { useMemo } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import { twMerge } from "tailwind-merge";

export type FieldBaseProps = {
  className?: string;
  error?: boolean;
  isLoading?: boolean;
  isSubmitting?: boolean;
  disabled?: boolean;
  required?: boolean;
  isWithIcon?: boolean;
  prefix?: string;
  register?: UseFormRegisterReturn<any>;
  autoComplete?: "current-password" | "new-password";
};

export function useFieldProps({
  className,
  error,
  isLoading,
  isSubmitting,
  required,
  isWithIcon,
  prefix,
}: FieldBaseProps) {
  const composedClassName = useMemo(
    () =>
      twMerge(
        "border rounded-sm bg-transparent text-sm shadow-sm transition-colors px-3 py-2 w-full",
        "disabled:cursor-not-allowed disabled:bg-brand-100 disabled:text-brand-300 disabled:border-brand-300",
        "placeholder:text-brand-400",
        error && "border-error-600 border-2",
        prefix ? "rounded-l-none" : "rounded-sm",
        isWithIcon && "pl-10",
        isLoading && "opacity-50",
        isSubmitting && "opacity-50",
        className
      ),
    [className, error, isLoading, isSubmitting, prefix, isWithIcon]
  );

  return {
    className: composedClassName,
    "aria-invalid": !!error,
    required,
  };
}

export default useFieldProps;
